module.exports = __webpack_public_path__ + "media/images/payment-details-7c60bef9.svg";